import { ModuleSetting, NewModuleSetting } from "@models";
import { isAfter } from "date-fns";
import _ from "lodash";
import { startDateOnSplit } from "./util";

export default function copyModuleSetting(
	moduleSetting: ModuleSetting
): NewModuleSetting {
	const deepCopy = _.cloneDeep(moduleSetting);
	const cleaned = _.omit(deepCopy, "moduleSettingId");
	// Copy operation usually makes sense when there's a need to split the module setting.
	// So, for convenience, update the start date accordingly.
	const availableFrom = startDateOnSplit(moduleSetting.category);
	return {
		...cleaned,
		availableFrom,
		availableUntil:
			moduleSetting.availableUntil &&
			isAfter(moduleSetting.availableUntil, availableFrom)
				? moduleSetting.availableUntil
				: null,
	};
}
